<template>
  <fieldset :id="tabID" class="TabBody" :disabled="disabled">
    <div :tabID="tabID" class="TabButton" :class="{Selected:isSelected}" @click="tabButtonClick">
      <div class="TabButtonFocus" contenteditable="true" @keydown.stop="tabButtonKeyDown"></div>
      {{heading}}
    </div>
    <slot>Tab Body</slot>
  </fieldset>
</template>
<script>
export default {
  props: {
    heading: { default: "Tab" },
    isSelected: { type: Boolean, default: false },
    index: { default: null },
    disabled: { type: Boolean, default: false }
  },
  model: {
    event: "change"
  },
  data() {
    return {
      tabID: "tab_" + parseInt(Math.random() * 1000000)
    };
  },
  methods: {
    tabButtonClick(e) {
      if (e.target.closest("[disabled]")) {
        return;
      }
      let tabID = e.target.getAttribute("tabID");
      if (tabID) {
        let index = 0;
        e.target.parentNode.querySelectorAll(".TabButton").forEach(x => {
          if (x === e.target) {
            if (!x.classList.contains("Selected")) {
              this.$emit("change", this.index || index);
            }
            x.addClass("Selected");
            x.parentNode.parentNode
              .querySelector("#" + tabID)
              .addClass("Active");
          } else {
            x.removeClass("Selected");
            x.parentNode.parentNode
              .querySelector("#" + x.getAttribute("tabID"))
              .removeClass("Active");
          }
          index++;
        });
      }
    },
    tabButtonKeyDown(e) {
      if (e.which === 9) {
      } else if (e.which === 13) {
        e.target.parentNode.click();
        e.preventDefault();
        e.stopPropagation();
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  },
  mounted() {
    let tab = document.querySelector("#" + this.tabID);
    if (tab) {
      let tabControl = tab.parentNode;
      tabControl.addClass("TabControl");
      let tabs = tabControl.querySelector(".Tabs");
      if (!tabs) {
        tabs = document.createElement("div");
        tabs.addClass("Tabs");
        tabControl.insertBefore(tabs, tab);
      }
      let tabButton = tab.querySelector(".TabButton");
      tabs.querySelectorAll(".TabButton").forEach(x => {
        let tabID = x.getAttribute("tabID");
        if (!tabControl.querySelector("#" + tabID)) {
          tabs.removeChild(x);
        }
      });
      tabs.appendChild(tabButton);
      if (this.isSelected) {
        tab.addClass("Active");
      } else {
        tab.removeClass("Active");
      }
    }
  }
};
</script>
<style>
.TabControl {
  display: flex;
  flex-direction: column;
}
.Tabs {
  padding-left: 5px;
  display: flex;
}
.TabButton {
  border: solid 2px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 3px 3px 0px 0px;
  padding: 5px 12px;
  margin: 1px;
  margin-bottom: -1px;
  cursor: pointer;
  position: relative;
}
.TabButton.Selected {
  border: solid 2px;
  background-color: rgba(0, 0, 0, 0.8);
}
.TabButtonFocus {
  display: block;
  position: absolute;
  color: black;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}
.TabButton:focus-within {
  outline: dotted 1px;
}
.TabBody {
  flex-grow: 1;
  flex-shrink: 1;
  padding: 5px;
  border: solid 1px;
  border-radius: 3px;
  overflow: auto;
  display: none;
}
.TabBody.Active {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/Tab.vue